(() => {
  const mq = window.matchMedia('(min-width: 1000px)');
  const CLOSE_DELAY = 120;

  function closeNested(root) {
    root.querySelectorAll('.header__dropdown-menu details.header__menu-disclosure[open]').forEach((d) => {
      d.removeAttribute('open');
      d.setAttribute('aria-expanded', 'false');
    });
  }

  function setupDetails(details, isTopLevel) {
    if (details.dataset.registaV13Ready === 'true') return;
    details.dataset.registaV13Ready = 'true';
    let timer = null;

    const open = () => {
      if (!mq.matches) return;
      window.clearTimeout(timer);
      if (isTopLevel) {
        document.querySelectorAll('.header__primary-nav-item > details.header__menu-disclosure[open]').forEach((other) => {
          if (other !== details) {
            other.removeAttribute('open');
            other.setAttribute('aria-expanded', 'false');
            closeNested(other);
          }
        });
      } else {
        const parentList = details.closest('.header__dropdown-menu');
        if (parentList) {
          parentList.querySelectorAll(':scope > li > details.header__menu-disclosure[open]').forEach((other) => {
            if (other !== details) {
              other.removeAttribute('open');
              other.setAttribute('aria-expanded', 'false');
            }
          });
        }
      }
      details.setAttribute('open', '');
      details.setAttribute('aria-expanded', 'true');
    };

    const close = () => {
      if (!mq.matches) return;
      window.clearTimeout(timer);
      timer = window.setTimeout(() => {
        details.removeAttribute('open');
        details.setAttribute('aria-expanded', 'false');
        closeNested(details);
      }, CLOSE_DELAY);
    };

    details.addEventListener('mouseenter', open);
    details.addEventListener('mouseleave', close);
    details.addEventListener('focusin', open);
    details.addEventListener('focusout', (event) => {
      if (!details.contains(event.relatedTarget)) close();
    });

    const summary = details.querySelector(':scope > summary');
    if (summary) {
      summary.addEventListener('click', (event) => {
        if (!mq.matches) return;
        event.preventDefault();
        open();
      });
    }
  }

  function init() {
    document.querySelectorAll('.header__primary-nav-item > details.header__menu-disclosure').forEach((details) => setupDetails(details, true));
    document.querySelectorAll('.header__dropdown-menu details.header__menu-disclosure').forEach((details) => setupDetails(details, false));
    if (!mq.matches) {
      document.querySelectorAll('.header__primary-nav details.header__menu-disclosure[open]').forEach((details) => {
        details.removeAttribute('open');
        details.removeAttribute('aria-expanded');
      });
    }
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  mq.addEventListener?.('change', init);
})();
